import React, { useState } from 'react';
import { Button } from '../../Button';
import { logEvent } from '../../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../../lib/shared/event-types';
import styles from './MemoryShare.css';

function MemoryShare() {
    const [isComingSoonVisible, setIsComingSoonVisible] = useState(false);

    const handleShareInterestClick = () => {
        logEvent(EVENT_TYPES.MEMORY_KEEPER_SHARE_INTEREST_CLICKED);
        setIsComingSoonVisible(true);
    };

    return (
        <section className={styles.root}>
            <h1 className={styles.title}>Share</h1>
            <p className={styles.subtitle}>Share your memories with the people who matter most.</p>

            <div className={styles.card}>
                <div className={styles.cardIntro}>
                    <h2 className={styles.cardTitle}>Share your memories</h2>
                    <p className={styles.cardText}>
                        Share your chapters with family and friends through a private, codeword-protected link.
                    </p>
                </div>
                <Button
                    label={isComingSoonVisible ? 'Coming soon' : 'Share my memories'}
                    type='primary'
                    iconLeft={{ name: isComingSoonVisible ? 'clock' : 'share' }}
                    disabled={isComingSoonVisible}
                    buttonProps={{ type: 'button' }}
                    onClick={handleShareInterestClick}
                    className={styles.cardButton}
                />
            </div>
        </section>
    );
}

export {
    MemoryShare
};
